const colors = {
  transparent: 'transparent',
  black: '#000',
  white: '#fff',
  gray: {
    50: '#f7fafc',
    900: '#171923'
  },
  blue: '#55ACD8',
  cyan: '#1BCE9F',
  orange: '#FF7A59',
  link: '#1F4CED',
  shade: '#E3EBEF'
};

export default colors;
